

export const getPRNfrmLSN = (LSN) => {
    if (LSN) {
        return LSN.substring(9, 17);
    } else {
        return '';
    }
}
